export default "__VITE_ASSET__Bapiauhz__"